import { Alert } from 'react-bootstrap';

import * as Revisions from '../../helpers/revisions';
import { nuc } from '../../utils';
import { RouterLink } from '../generic';

import './RevisionStatusBanner.less';
import type { ProjectDashboardProject, ProjectDashboardRevision } from './projectDashboardTypes';

export type RevisionStatusBannerParams = {
  project_id?: string, // eslint-disable-line @typescript-eslint/naming-convention -- Param name already exists.
  revision_id?: string, // eslint-disable-line @typescript-eslint/naming-convention -- Param name already exists.
  reference_type?: string, // eslint-disable-line @typescript-eslint/naming-convention -- Param name already exists.
  reference?: string,
};

export type Props = {
  project?: ProjectDashboardProject;
  revision?: ProjectDashboardRevision;
  params: RevisionStatusBannerParams;
};

export const RevisionStatusBanner = ({ project, revision, params }: Props) => {
  // Don't show the banner if we aren't in a project context.
  if (!params.project_id || !params.reference || !params.revision_id || !params.reference_type) {
    return null;
  }

  // Show the revision if it's analyzing and we don't have a previous scan.
  if (project?.status.loading
    || revision?.status.loading
    || !revision?.data
    || Revisions.isAnalyzing(revision.data)) {
    // NOTE: This route duplicates logic in DisplayProjectNav.  That component
    // needs to be rewritten and the routing logic extracted.
    const baseUrl = `/projects/${nuc(params.project_id)}/`;
    const revisionUrl = `${baseUrl}refs/${params.reference_type}/${nuc(params.reference)}/${nuc(params.revision_id)}`;
    const dependenciesUrl = `${revisionUrl}/browse/dependencies`;
    return (
      <div className="revision-status-banner margin-top">
        <RouterLink to={dependenciesUrl} className="revision-status-banner__link">
          <Alert kind="info" className="revision-status-banner__alert">
            FOSSA is still analyzing dependencies for this revision...
          </Alert>
        </RouterLink>
      </div>
    );
  }

  return null;
};
